const INVALID_FILE_NAME_CHARS = /[\\/:*?"<>|#%&+=';]/g;

const normalizeSegment = (segment: string) => segment.replace(INVALID_FILE_NAME_CHARS, '').replace(/\s+/g, '_').trim();

export const sanitizeFileName = (fileName: string): string => {
  if (!fileName) {
    return 'file';
  }

  const lastDotIndex = fileName.lastIndexOf('.');
  const hasExtension = lastDotIndex > 0 && lastDotIndex < fileName.length - 1;

  const rawName = hasExtension ? fileName.slice(0, lastDotIndex) : fileName;
  const rawExtension = hasExtension ? fileName.slice(lastDotIndex + 1) : '';

  const safeName = normalizeSegment(rawName) || 'file';
  const safeExtension = normalizeSegment(rawExtension);

  if (!safeExtension) {
    return safeName;
  }

  return `${safeName}.${safeExtension}`;
};

export const sanitizeFileForUpload = (file: File): File => {
  const safeName = sanitizeFileName(file.name);
  if (safeName === file.name) {
    return file;
  }

  return new File([file], safeName, { type: file.type, lastModified: file.lastModified });
};
